import { SubmitButton } from "./SubmitButton";

interface AuthPromptCardProps {
  heading: string;
  description: string;
  cta: string;
  isBusy?: boolean;
  busyLabel?: string;
  onAction: () => void;
}

export const AuthPromptCard = ({
  heading,
  description,
  cta,
  isBusy = false,
  busyLabel,
  onAction,
}: AuthPromptCardProps) => {
  return (
    <div className="flex flex-col gap-[26px]">
      <div>
        <h2 className="mb-2 text-2xl font-bold text-foreground">{heading}</h2>
        <p className="text-sm leading-[1.55] text-muted-foreground">{description}</p>
      </div>

      <SubmitButton type="button" isSubmitting={isBusy} loadingLabel={busyLabel} onClick={onAction}>
        {cta}
      </SubmitButton>
    </div>
  );
};
